var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"yesno"},_vm._l((Object.entries(_vm.options || _vm.defaultOptions)),function(ref){
var key = ref[0];
var text = ref[1];
return _c('span',{key:key,staticClass:"yesno__option",class:{ yesno__option_active: _vm.value === key },on:{"click":function($event){return _vm.$emit('input', key)}}},[_vm._v("\n    "+_vm._s(text)+"\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }